import { createActionCreators, createReducerFunction, ImmerReducer } from 'immer-reducer';
import { CashierPreferences } from '../../interfaces/dtos/CashierPreferences';
import { CashierPreferenceLevel, SizeType } from '../../enumerations/cashier-preference-level';

export const initialState: CashierPreferences = {
  leftHanded: false,
  contrastLevel: CashierPreferenceLevel.Zero,
  buttonZoomLevel: SizeType.Medium,
  textZoomLevel: SizeType.Medium,
};

class CashierPreferencesReducer extends ImmerReducer<CashierPreferences> {
  public setCashierPreferences(cashierPreferences: CashierPreferences): void {
    this.setCashierPreferencesState(
      cashierPreferences.leftHanded,
      cashierPreferences.contrastLevel,
      cashierPreferences.buttonZoomLevel,
      cashierPreferences.textZoomLevel,
    );
  }

  private setCashierPreferencesState(
    leftHanded: boolean,
    contrastLevel: CashierPreferenceLevel,
    buttonZoomLevel: SizeType,
    textZoomLevel: SizeType,
  ): void {
    this.draftState = {
      ...this.draftState,
      leftHanded,
      contrastLevel,
      buttonZoomLevel,
      textZoomLevel,
    };
  }

  public resetState(): void {
    this.draftState = initialState;
  }
}

export const CashierPreferencesActions = createActionCreators(CashierPreferencesReducer);
export const CashierPreferencesReducerFunction = createReducerFunction(
  CashierPreferencesReducer,
  initialState,
);
